import styled from 'styled-components';

const StyledNoResults = styled.div`
  align-items: center;
  border-top: 1px solid #eaeaea;
  color: #717171;
  display: flex;
  justify-content: center;
  padding: 20px;
  width: 100%;
`;

// type Props = {
//   children: React.Node,
// };

export const NoResults = ({ children = 'No results' }) => (
  <StyledNoResults>{children}</StyledNoResults>
);
